import React from 'react';
import PropTypes from "prop-types";
import {OutlineSuccessIcon} from "presentation/common/components/style-guide/icons";
import {Button} from "presentation/common/components";
import styles from './SuccessMessage.module.scss';
import clsx from "clsx";
import {emptyFn} from "presentation/common/helpers/utils";

export const SuccessMessageContent = (props) => {
  const {message, title, Icon = OutlineSuccessIcon, onClose} = props;

  return (
    <div className={styles.container}>
      <div className="text-center mb-2 lg:mb-3"><Icon stroke="#FFB350"/></div>
      <div className="pb-2 lg:pb-0">
        <h3 className={clsx("text-lg text-center lg:pt-1 pb-2", styles.title)}>{title}</h3>
        <p className={clsx("text-center pb-6", styles.message)}>{message}</p>
      </div>

      <div className="text-center">
        <Button label="Aceptar" onClick={onClose}/>
      </div>
    </div>
  );
};

SuccessMessageContent.defaultProps = {
  title: '¡Pago Exitoso!',
  message: 'Pago realizado exitosamente. Le enviaremos por correo electrónico el comprobante de pago y lo mantendremos informado del avance del proceso.',
  onClose: emptyFn,
};

SuccessMessageContent.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  onClose: PropTypes.func,
};

export default React.memo(SuccessMessageContent);
